<div class="md:mb-0 md:flex-none md:w-[40%] 2xl:w-[35%] relative transition-all mb-1" :style="mapStore.showMap ? {'width': ''} : {'width': '0'}" ref="targetComponent" >
    <div
        :id="config.map.mapId"
        data-isloaded="false"
        :style="mapStore.showMap ? {'height': '92vh', 'opacity': '1', 'visibility': 'visible', 'width': '100%', 'minHeight': '400px'} : {'height': '0', 'opacity': '0', 'visibility': 'hidden', 'width': '0', 'minHeight': '0'}"
        class="md:!sticky md:!top-[80px]"
    >
        <div class="absolute bottom-1 left-0 text-center w-full" v-if="mapStore.showSearchButton || resultsStore.loading">
            <button class="button small white shadow-lg relative" style="z-index:999" v-if="resultsStore.loading" disabled>
                Searching...
            </button>
            <button class="button small white shadow-lg relative" style="z-index:999" v-else v-on:click="searchByBounds">
                Search this area?
            </button>
        </div>

        <button :class="{ 'map-button': mapStore.showMap, 'md:hidden': !mapStore.showMap }" class="button small white shadow-lg fixed bottom-1 md:bottom-auto  mx-auto md:absolute w-[120px] right-0 md:left-auto  left-0 md:right-1 md:top-1 z-[999]" v-on:click="toggleMap">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 inline-block">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
            </svg>
        
            <template v-if="mapStore.showMap">
                Hide Map
            </template>
            <template v-else>
                Show Map
            </template>
        </button>

    </div>
    
</div>

